import { render, staticRenderFns } from "./HighlihgtedCategories.vue?vue&type=template&id=2f5d6a94&scoped=true"
import script from "./HighlihgtedCategories.vue?vue&type=script&lang=js"
export * from "./HighlihgtedCategories.vue?vue&type=script&lang=js"
import style0 from "./HighlihgtedCategories.vue?vue&type=style&index=0&id=2f5d6a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d6a94",
  null
  
)

export default component.exports